/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as CreditsRouteImport } from './routes/credits'
import { Route as ColorsRouteImport } from './routes/colors'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DesignSystemIndexRouteImport } from './routes/design-system.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as DesignSystemSectionsRouteImport } from './routes/design-system.sections'
import { Route as DesignSystemSavedRouteImport } from './routes/design-system.saved'
import { Route as DesignSystemFontsRouteImport } from './routes/design-system.fonts'
import { Route as DesignSystemExploreRouteImport } from './routes/design-system.explore'
import { Route as DesignSystemComponentsRouteImport } from './routes/design-system.components'
import { Route as DesignSystemColorsRouteImport } from './routes/design-system.colors'
import { Route as DesignSystemCasingRouteImport } from './routes/design-system.casing'
import { Route as CampaignShortIdRouteImport } from './routes/campaign.$shortId'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminTilesRouteImport } from './routes/admin.tiles'
import { Route as AdminSystemCatalogRouteImport } from './routes/admin.system-catalog'
import { Route as AdminOverlaysRouteImport } from './routes/admin.overlays'
import { Route as AdminGenerateRouteImport } from './routes/admin.generate'
import { Route as AdminDesignSystemRouteImport } from './routes/admin.design-system'
import { Route as AdminCreateRouteImport } from './routes/admin.create'
import { Route as AdminComposeRouteImport } from './routes/admin.compose'
import { Route as CampaignShortIdIndexRouteImport } from './routes/campaign.$shortId.index'
import { Route as AdminDesignSystemIndexRouteImport } from './routes/admin.design-system.index'
import { Route as CampaignShortIdJoinRouteImport } from './routes/campaign.$shortId.join'
import { Route as AdminDesignSystemSectionsRouteImport } from './routes/admin.design-system.sections'
import { Route as AdminDesignSystemSavedRouteImport } from './routes/admin.design-system.saved'
import { Route as AdminDesignSystemFontsRouteImport } from './routes/admin.design-system.fonts'
import { Route as AdminDesignSystemExploreRouteImport } from './routes/admin.design-system.explore'
import { Route as AdminDesignSystemComponentsRouteImport } from './routes/admin.design-system.components'
import { Route as AdminDesignSystemColorsRouteImport } from './routes/admin.design-system.colors'
import { Route as AdminDesignSystemCasingRouteImport } from './routes/admin.design-system.casing'
import { Route as CampaignShortIdMapNoteMapNoteIdRouteImport } from './routes/campaign.$shortId.map-note.$mapNoteId'
import { Route as CampaignShortIdMapNoteMapNoteIdEntryEntryIdRouteImport } from './routes/campaign.$shortId.map-note.$mapNoteId.entry.$entryId'

const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemRoute = DesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => rootRouteImport,
} as any)
const CreditsRoute = CreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => rootRouteImport,
} as any)
const ColorsRoute = ColorsRouteImport.update({
  id: '/colors',
  path: '/colors',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemIndexRoute = DesignSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DesignSystemRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const DesignSystemSectionsRoute = DesignSystemSectionsRouteImport.update({
  id: '/sections',
  path: '/sections',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemSavedRoute = DesignSystemSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemFontsRoute = DesignSystemFontsRouteImport.update({
  id: '/fonts',
  path: '/fonts',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemExploreRoute = DesignSystemExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemComponentsRoute = DesignSystemComponentsRouteImport.update({
  id: '/components',
  path: '/components',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemColorsRoute = DesignSystemColorsRouteImport.update({
  id: '/colors',
  path: '/colors',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemCasingRoute = DesignSystemCasingRouteImport.update({
  id: '/casing',
  path: '/casing',
  getParentRoute: () => DesignSystemRoute,
} as any)
const CampaignShortIdRoute = CampaignShortIdRouteImport.update({
  id: '/campaign/$shortId',
  path: '/campaign/$shortId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTilesRoute = AdminTilesRouteImport.update({
  id: '/tiles',
  path: '/tiles',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemCatalogRoute = AdminSystemCatalogRouteImport.update({
  id: '/system-catalog',
  path: '/system-catalog',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOverlaysRoute = AdminOverlaysRouteImport.update({
  id: '/overlays',
  path: '/overlays',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGenerateRoute = AdminGenerateRouteImport.update({
  id: '/generate',
  path: '/generate',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDesignSystemRoute = AdminDesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCreateRoute = AdminCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AdminRoute,
} as any)
const AdminComposeRoute = AdminComposeRouteImport.update({
  id: '/compose',
  path: '/compose',
  getParentRoute: () => AdminRoute,
} as any)
const CampaignShortIdIndexRoute = CampaignShortIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CampaignShortIdRoute,
} as any)
const AdminDesignSystemIndexRoute = AdminDesignSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminDesignSystemRoute,
} as any)
const CampaignShortIdJoinRoute = CampaignShortIdJoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => CampaignShortIdRoute,
} as any)
const AdminDesignSystemSectionsRoute =
  AdminDesignSystemSectionsRouteImport.update({
    id: '/sections',
    path: '/sections',
    getParentRoute: () => AdminDesignSystemRoute,
  } as any)
const AdminDesignSystemSavedRoute = AdminDesignSystemSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => AdminDesignSystemRoute,
} as any)
const AdminDesignSystemFontsRoute = AdminDesignSystemFontsRouteImport.update({
  id: '/fonts',
  path: '/fonts',
  getParentRoute: () => AdminDesignSystemRoute,
} as any)
const AdminDesignSystemExploreRoute =
  AdminDesignSystemExploreRouteImport.update({
    id: '/explore',
    path: '/explore',
    getParentRoute: () => AdminDesignSystemRoute,
  } as any)
const AdminDesignSystemComponentsRoute =
  AdminDesignSystemComponentsRouteImport.update({
    id: '/components',
    path: '/components',
    getParentRoute: () => AdminDesignSystemRoute,
  } as any)
const AdminDesignSystemColorsRoute = AdminDesignSystemColorsRouteImport.update({
  id: '/colors',
  path: '/colors',
  getParentRoute: () => AdminDesignSystemRoute,
} as any)
const AdminDesignSystemCasingRoute = AdminDesignSystemCasingRouteImport.update({
  id: '/casing',
  path: '/casing',
  getParentRoute: () => AdminDesignSystemRoute,
} as any)
const CampaignShortIdMapNoteMapNoteIdRoute =
  CampaignShortIdMapNoteMapNoteIdRouteImport.update({
    id: '/map-note/$mapNoteId',
    path: '/map-note/$mapNoteId',
    getParentRoute: () => CampaignShortIdRoute,
  } as any)
const CampaignShortIdMapNoteMapNoteIdEntryEntryIdRoute =
  CampaignShortIdMapNoteMapNoteIdEntryEntryIdRouteImport.update({
    id: '/entry/$entryId',
    path: '/entry/$entryId',
    getParentRoute: () => CampaignShortIdMapNoteMapNoteIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/colors': typeof ColorsRoute
  '/credits': typeof CreditsRoute
  '/design-system': typeof DesignSystemRouteWithChildren
  '/profile': typeof ProfileRoute
  '/admin/compose': typeof AdminComposeRoute
  '/admin/create': typeof AdminCreateRoute
  '/admin/design-system': typeof AdminDesignSystemRouteWithChildren
  '/admin/generate': typeof AdminGenerateRoute
  '/admin/overlays': typeof AdminOverlaysRoute
  '/admin/system-catalog': typeof AdminSystemCatalogRoute
  '/admin/tiles': typeof AdminTilesRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/campaign/$shortId': typeof CampaignShortIdRouteWithChildren
  '/design-system/casing': typeof DesignSystemCasingRoute
  '/design-system/colors': typeof DesignSystemColorsRoute
  '/design-system/components': typeof DesignSystemComponentsRoute
  '/design-system/explore': typeof DesignSystemExploreRoute
  '/design-system/fonts': typeof DesignSystemFontsRoute
  '/design-system/saved': typeof DesignSystemSavedRoute
  '/design-system/sections': typeof DesignSystemSectionsRoute
  '/admin/': typeof AdminIndexRoute
  '/design-system/': typeof DesignSystemIndexRoute
  '/admin/design-system/casing': typeof AdminDesignSystemCasingRoute
  '/admin/design-system/colors': typeof AdminDesignSystemColorsRoute
  '/admin/design-system/components': typeof AdminDesignSystemComponentsRoute
  '/admin/design-system/explore': typeof AdminDesignSystemExploreRoute
  '/admin/design-system/fonts': typeof AdminDesignSystemFontsRoute
  '/admin/design-system/saved': typeof AdminDesignSystemSavedRoute
  '/admin/design-system/sections': typeof AdminDesignSystemSectionsRoute
  '/campaign/$shortId/join': typeof CampaignShortIdJoinRoute
  '/admin/design-system/': typeof AdminDesignSystemIndexRoute
  '/campaign/$shortId/': typeof CampaignShortIdIndexRoute
  '/campaign/$shortId/map-note/$mapNoteId': typeof CampaignShortIdMapNoteMapNoteIdRouteWithChildren
  '/campaign/$shortId/map-note/$mapNoteId/entry/$entryId': typeof CampaignShortIdMapNoteMapNoteIdEntryEntryIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/colors': typeof ColorsRoute
  '/credits': typeof CreditsRoute
  '/profile': typeof ProfileRoute
  '/admin/compose': typeof AdminComposeRoute
  '/admin/create': typeof AdminCreateRoute
  '/admin/generate': typeof AdminGenerateRoute
  '/admin/overlays': typeof AdminOverlaysRoute
  '/admin/system-catalog': typeof AdminSystemCatalogRoute
  '/admin/tiles': typeof AdminTilesRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/design-system/casing': typeof DesignSystemCasingRoute
  '/design-system/colors': typeof DesignSystemColorsRoute
  '/design-system/components': typeof DesignSystemComponentsRoute
  '/design-system/explore': typeof DesignSystemExploreRoute
  '/design-system/fonts': typeof DesignSystemFontsRoute
  '/design-system/saved': typeof DesignSystemSavedRoute
  '/design-system/sections': typeof DesignSystemSectionsRoute
  '/admin': typeof AdminIndexRoute
  '/design-system': typeof DesignSystemIndexRoute
  '/admin/design-system/casing': typeof AdminDesignSystemCasingRoute
  '/admin/design-system/colors': typeof AdminDesignSystemColorsRoute
  '/admin/design-system/components': typeof AdminDesignSystemComponentsRoute
  '/admin/design-system/explore': typeof AdminDesignSystemExploreRoute
  '/admin/design-system/fonts': typeof AdminDesignSystemFontsRoute
  '/admin/design-system/saved': typeof AdminDesignSystemSavedRoute
  '/admin/design-system/sections': typeof AdminDesignSystemSectionsRoute
  '/campaign/$shortId/join': typeof CampaignShortIdJoinRoute
  '/admin/design-system': typeof AdminDesignSystemIndexRoute
  '/campaign/$shortId': typeof CampaignShortIdIndexRoute
  '/campaign/$shortId/map-note/$mapNoteId': typeof CampaignShortIdMapNoteMapNoteIdRouteWithChildren
  '/campaign/$shortId/map-note/$mapNoteId/entry/$entryId': typeof CampaignShortIdMapNoteMapNoteIdEntryEntryIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/colors': typeof ColorsRoute
  '/credits': typeof CreditsRoute
  '/design-system': typeof DesignSystemRouteWithChildren
  '/profile': typeof ProfileRoute
  '/admin/compose': typeof AdminComposeRoute
  '/admin/create': typeof AdminCreateRoute
  '/admin/design-system': typeof AdminDesignSystemRouteWithChildren
  '/admin/generate': typeof AdminGenerateRoute
  '/admin/overlays': typeof AdminOverlaysRoute
  '/admin/system-catalog': typeof AdminSystemCatalogRoute
  '/admin/tiles': typeof AdminTilesRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/campaign/$shortId': typeof CampaignShortIdRouteWithChildren
  '/design-system/casing': typeof DesignSystemCasingRoute
  '/design-system/colors': typeof DesignSystemColorsRoute
  '/design-system/components': typeof DesignSystemComponentsRoute
  '/design-system/explore': typeof DesignSystemExploreRoute
  '/design-system/fonts': typeof DesignSystemFontsRoute
  '/design-system/saved': typeof DesignSystemSavedRoute
  '/design-system/sections': typeof DesignSystemSectionsRoute
  '/admin/': typeof AdminIndexRoute
  '/design-system/': typeof DesignSystemIndexRoute
  '/admin/design-system/casing': typeof AdminDesignSystemCasingRoute
  '/admin/design-system/colors': typeof AdminDesignSystemColorsRoute
  '/admin/design-system/components': typeof AdminDesignSystemComponentsRoute
  '/admin/design-system/explore': typeof AdminDesignSystemExploreRoute
  '/admin/design-system/fonts': typeof AdminDesignSystemFontsRoute
  '/admin/design-system/saved': typeof AdminDesignSystemSavedRoute
  '/admin/design-system/sections': typeof AdminDesignSystemSectionsRoute
  '/campaign/$shortId/join': typeof CampaignShortIdJoinRoute
  '/admin/design-system/': typeof AdminDesignSystemIndexRoute
  '/campaign/$shortId/': typeof CampaignShortIdIndexRoute
  '/campaign/$shortId/map-note/$mapNoteId': typeof CampaignShortIdMapNoteMapNoteIdRouteWithChildren
  '/campaign/$shortId/map-note/$mapNoteId/entry/$entryId': typeof CampaignShortIdMapNoteMapNoteIdEntryEntryIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/colors'
    | '/credits'
    | '/design-system'
    | '/profile'
    | '/admin/compose'
    | '/admin/create'
    | '/admin/design-system'
    | '/admin/generate'
    | '/admin/overlays'
    | '/admin/system-catalog'
    | '/admin/tiles'
    | '/admin/users'
    | '/auth/callback'
    | '/campaign/$shortId'
    | '/design-system/casing'
    | '/design-system/colors'
    | '/design-system/components'
    | '/design-system/explore'
    | '/design-system/fonts'
    | '/design-system/saved'
    | '/design-system/sections'
    | '/admin/'
    | '/design-system/'
    | '/admin/design-system/casing'
    | '/admin/design-system/colors'
    | '/admin/design-system/components'
    | '/admin/design-system/explore'
    | '/admin/design-system/fonts'
    | '/admin/design-system/saved'
    | '/admin/design-system/sections'
    | '/campaign/$shortId/join'
    | '/admin/design-system/'
    | '/campaign/$shortId/'
    | '/campaign/$shortId/map-note/$mapNoteId'
    | '/campaign/$shortId/map-note/$mapNoteId/entry/$entryId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/colors'
    | '/credits'
    | '/profile'
    | '/admin/compose'
    | '/admin/create'
    | '/admin/generate'
    | '/admin/overlays'
    | '/admin/system-catalog'
    | '/admin/tiles'
    | '/admin/users'
    | '/auth/callback'
    | '/design-system/casing'
    | '/design-system/colors'
    | '/design-system/components'
    | '/design-system/explore'
    | '/design-system/fonts'
    | '/design-system/saved'
    | '/design-system/sections'
    | '/admin'
    | '/design-system'
    | '/admin/design-system/casing'
    | '/admin/design-system/colors'
    | '/admin/design-system/components'
    | '/admin/design-system/explore'
    | '/admin/design-system/fonts'
    | '/admin/design-system/saved'
    | '/admin/design-system/sections'
    | '/campaign/$shortId/join'
    | '/admin/design-system'
    | '/campaign/$shortId'
    | '/campaign/$shortId/map-note/$mapNoteId'
    | '/campaign/$shortId/map-note/$mapNoteId/entry/$entryId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/colors'
    | '/credits'
    | '/design-system'
    | '/profile'
    | '/admin/compose'
    | '/admin/create'
    | '/admin/design-system'
    | '/admin/generate'
    | '/admin/overlays'
    | '/admin/system-catalog'
    | '/admin/tiles'
    | '/admin/users'
    | '/auth/callback'
    | '/campaign/$shortId'
    | '/design-system/casing'
    | '/design-system/colors'
    | '/design-system/components'
    | '/design-system/explore'
    | '/design-system/fonts'
    | '/design-system/saved'
    | '/design-system/sections'
    | '/admin/'
    | '/design-system/'
    | '/admin/design-system/casing'
    | '/admin/design-system/colors'
    | '/admin/design-system/components'
    | '/admin/design-system/explore'
    | '/admin/design-system/fonts'
    | '/admin/design-system/saved'
    | '/admin/design-system/sections'
    | '/campaign/$shortId/join'
    | '/admin/design-system/'
    | '/campaign/$shortId/'
    | '/campaign/$shortId/map-note/$mapNoteId'
    | '/campaign/$shortId/map-note/$mapNoteId/entry/$entryId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ColorsRoute: typeof ColorsRoute
  CreditsRoute: typeof CreditsRoute
  DesignSystemRoute: typeof DesignSystemRouteWithChildren
  ProfileRoute: typeof ProfileRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  CampaignShortIdRoute: typeof CampaignShortIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system': {
      id: '/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof DesignSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/credits': {
      id: '/credits'
      path: '/credits'
      fullPath: '/credits'
      preLoaderRoute: typeof CreditsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/colors': {
      id: '/colors'
      path: '/colors'
      fullPath: '/colors'
      preLoaderRoute: typeof ColorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system/': {
      id: '/design-system/'
      path: '/'
      fullPath: '/design-system/'
      preLoaderRoute: typeof DesignSystemIndexRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/design-system/sections': {
      id: '/design-system/sections'
      path: '/sections'
      fullPath: '/design-system/sections'
      preLoaderRoute: typeof DesignSystemSectionsRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/saved': {
      id: '/design-system/saved'
      path: '/saved'
      fullPath: '/design-system/saved'
      preLoaderRoute: typeof DesignSystemSavedRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/fonts': {
      id: '/design-system/fonts'
      path: '/fonts'
      fullPath: '/design-system/fonts'
      preLoaderRoute: typeof DesignSystemFontsRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/explore': {
      id: '/design-system/explore'
      path: '/explore'
      fullPath: '/design-system/explore'
      preLoaderRoute: typeof DesignSystemExploreRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/components': {
      id: '/design-system/components'
      path: '/components'
      fullPath: '/design-system/components'
      preLoaderRoute: typeof DesignSystemComponentsRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/colors': {
      id: '/design-system/colors'
      path: '/colors'
      fullPath: '/design-system/colors'
      preLoaderRoute: typeof DesignSystemColorsRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/casing': {
      id: '/design-system/casing'
      path: '/casing'
      fullPath: '/design-system/casing'
      preLoaderRoute: typeof DesignSystemCasingRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/campaign/$shortId': {
      id: '/campaign/$shortId'
      path: '/campaign/$shortId'
      fullPath: '/campaign/$shortId'
      preLoaderRoute: typeof CampaignShortIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tiles': {
      id: '/admin/tiles'
      path: '/tiles'
      fullPath: '/admin/tiles'
      preLoaderRoute: typeof AdminTilesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/system-catalog': {
      id: '/admin/system-catalog'
      path: '/system-catalog'
      fullPath: '/admin/system-catalog'
      preLoaderRoute: typeof AdminSystemCatalogRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/overlays': {
      id: '/admin/overlays'
      path: '/overlays'
      fullPath: '/admin/overlays'
      preLoaderRoute: typeof AdminOverlaysRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/generate': {
      id: '/admin/generate'
      path: '/generate'
      fullPath: '/admin/generate'
      preLoaderRoute: typeof AdminGenerateRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/design-system': {
      id: '/admin/design-system'
      path: '/design-system'
      fullPath: '/admin/design-system'
      preLoaderRoute: typeof AdminDesignSystemRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/create': {
      id: '/admin/create'
      path: '/create'
      fullPath: '/admin/create'
      preLoaderRoute: typeof AdminCreateRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/compose': {
      id: '/admin/compose'
      path: '/compose'
      fullPath: '/admin/compose'
      preLoaderRoute: typeof AdminComposeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/campaign/$shortId/': {
      id: '/campaign/$shortId/'
      path: '/'
      fullPath: '/campaign/$shortId/'
      preLoaderRoute: typeof CampaignShortIdIndexRouteImport
      parentRoute: typeof CampaignShortIdRoute
    }
    '/admin/design-system/': {
      id: '/admin/design-system/'
      path: '/'
      fullPath: '/admin/design-system/'
      preLoaderRoute: typeof AdminDesignSystemIndexRouteImport
      parentRoute: typeof AdminDesignSystemRoute
    }
    '/campaign/$shortId/join': {
      id: '/campaign/$shortId/join'
      path: '/join'
      fullPath: '/campaign/$shortId/join'
      preLoaderRoute: typeof CampaignShortIdJoinRouteImport
      parentRoute: typeof CampaignShortIdRoute
    }
    '/admin/design-system/sections': {
      id: '/admin/design-system/sections'
      path: '/sections'
      fullPath: '/admin/design-system/sections'
      preLoaderRoute: typeof AdminDesignSystemSectionsRouteImport
      parentRoute: typeof AdminDesignSystemRoute
    }
    '/admin/design-system/saved': {
      id: '/admin/design-system/saved'
      path: '/saved'
      fullPath: '/admin/design-system/saved'
      preLoaderRoute: typeof AdminDesignSystemSavedRouteImport
      parentRoute: typeof AdminDesignSystemRoute
    }
    '/admin/design-system/fonts': {
      id: '/admin/design-system/fonts'
      path: '/fonts'
      fullPath: '/admin/design-system/fonts'
      preLoaderRoute: typeof AdminDesignSystemFontsRouteImport
      parentRoute: typeof AdminDesignSystemRoute
    }
    '/admin/design-system/explore': {
      id: '/admin/design-system/explore'
      path: '/explore'
      fullPath: '/admin/design-system/explore'
      preLoaderRoute: typeof AdminDesignSystemExploreRouteImport
      parentRoute: typeof AdminDesignSystemRoute
    }
    '/admin/design-system/components': {
      id: '/admin/design-system/components'
      path: '/components'
      fullPath: '/admin/design-system/components'
      preLoaderRoute: typeof AdminDesignSystemComponentsRouteImport
      parentRoute: typeof AdminDesignSystemRoute
    }
    '/admin/design-system/colors': {
      id: '/admin/design-system/colors'
      path: '/colors'
      fullPath: '/admin/design-system/colors'
      preLoaderRoute: typeof AdminDesignSystemColorsRouteImport
      parentRoute: typeof AdminDesignSystemRoute
    }
    '/admin/design-system/casing': {
      id: '/admin/design-system/casing'
      path: '/casing'
      fullPath: '/admin/design-system/casing'
      preLoaderRoute: typeof AdminDesignSystemCasingRouteImport
      parentRoute: typeof AdminDesignSystemRoute
    }
    '/campaign/$shortId/map-note/$mapNoteId': {
      id: '/campaign/$shortId/map-note/$mapNoteId'
      path: '/map-note/$mapNoteId'
      fullPath: '/campaign/$shortId/map-note/$mapNoteId'
      preLoaderRoute: typeof CampaignShortIdMapNoteMapNoteIdRouteImport
      parentRoute: typeof CampaignShortIdRoute
    }
    '/campaign/$shortId/map-note/$mapNoteId/entry/$entryId': {
      id: '/campaign/$shortId/map-note/$mapNoteId/entry/$entryId'
      path: '/entry/$entryId'
      fullPath: '/campaign/$shortId/map-note/$mapNoteId/entry/$entryId'
      preLoaderRoute: typeof CampaignShortIdMapNoteMapNoteIdEntryEntryIdRouteImport
      parentRoute: typeof CampaignShortIdMapNoteMapNoteIdRoute
    }
  }
}

interface AdminDesignSystemRouteChildren {
  AdminDesignSystemCasingRoute: typeof AdminDesignSystemCasingRoute
  AdminDesignSystemColorsRoute: typeof AdminDesignSystemColorsRoute
  AdminDesignSystemComponentsRoute: typeof AdminDesignSystemComponentsRoute
  AdminDesignSystemExploreRoute: typeof AdminDesignSystemExploreRoute
  AdminDesignSystemFontsRoute: typeof AdminDesignSystemFontsRoute
  AdminDesignSystemSavedRoute: typeof AdminDesignSystemSavedRoute
  AdminDesignSystemSectionsRoute: typeof AdminDesignSystemSectionsRoute
  AdminDesignSystemIndexRoute: typeof AdminDesignSystemIndexRoute
}

const AdminDesignSystemRouteChildren: AdminDesignSystemRouteChildren = {
  AdminDesignSystemCasingRoute: AdminDesignSystemCasingRoute,
  AdminDesignSystemColorsRoute: AdminDesignSystemColorsRoute,
  AdminDesignSystemComponentsRoute: AdminDesignSystemComponentsRoute,
  AdminDesignSystemExploreRoute: AdminDesignSystemExploreRoute,
  AdminDesignSystemFontsRoute: AdminDesignSystemFontsRoute,
  AdminDesignSystemSavedRoute: AdminDesignSystemSavedRoute,
  AdminDesignSystemSectionsRoute: AdminDesignSystemSectionsRoute,
  AdminDesignSystemIndexRoute: AdminDesignSystemIndexRoute,
}

const AdminDesignSystemRouteWithChildren =
  AdminDesignSystemRoute._addFileChildren(AdminDesignSystemRouteChildren)

interface AdminRouteChildren {
  AdminComposeRoute: typeof AdminComposeRoute
  AdminCreateRoute: typeof AdminCreateRoute
  AdminDesignSystemRoute: typeof AdminDesignSystemRouteWithChildren
  AdminGenerateRoute: typeof AdminGenerateRoute
  AdminOverlaysRoute: typeof AdminOverlaysRoute
  AdminSystemCatalogRoute: typeof AdminSystemCatalogRoute
  AdminTilesRoute: typeof AdminTilesRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminComposeRoute: AdminComposeRoute,
  AdminCreateRoute: AdminCreateRoute,
  AdminDesignSystemRoute: AdminDesignSystemRouteWithChildren,
  AdminGenerateRoute: AdminGenerateRoute,
  AdminOverlaysRoute: AdminOverlaysRoute,
  AdminSystemCatalogRoute: AdminSystemCatalogRoute,
  AdminTilesRoute: AdminTilesRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DesignSystemRouteChildren {
  DesignSystemCasingRoute: typeof DesignSystemCasingRoute
  DesignSystemColorsRoute: typeof DesignSystemColorsRoute
  DesignSystemComponentsRoute: typeof DesignSystemComponentsRoute
  DesignSystemExploreRoute: typeof DesignSystemExploreRoute
  DesignSystemFontsRoute: typeof DesignSystemFontsRoute
  DesignSystemSavedRoute: typeof DesignSystemSavedRoute
  DesignSystemSectionsRoute: typeof DesignSystemSectionsRoute
  DesignSystemIndexRoute: typeof DesignSystemIndexRoute
}

const DesignSystemRouteChildren: DesignSystemRouteChildren = {
  DesignSystemCasingRoute: DesignSystemCasingRoute,
  DesignSystemColorsRoute: DesignSystemColorsRoute,
  DesignSystemComponentsRoute: DesignSystemComponentsRoute,
  DesignSystemExploreRoute: DesignSystemExploreRoute,
  DesignSystemFontsRoute: DesignSystemFontsRoute,
  DesignSystemSavedRoute: DesignSystemSavedRoute,
  DesignSystemSectionsRoute: DesignSystemSectionsRoute,
  DesignSystemIndexRoute: DesignSystemIndexRoute,
}

const DesignSystemRouteWithChildren = DesignSystemRoute._addFileChildren(
  DesignSystemRouteChildren,
)

interface CampaignShortIdMapNoteMapNoteIdRouteChildren {
  CampaignShortIdMapNoteMapNoteIdEntryEntryIdRoute: typeof CampaignShortIdMapNoteMapNoteIdEntryEntryIdRoute
}

const CampaignShortIdMapNoteMapNoteIdRouteChildren: CampaignShortIdMapNoteMapNoteIdRouteChildren =
  {
    CampaignShortIdMapNoteMapNoteIdEntryEntryIdRoute:
      CampaignShortIdMapNoteMapNoteIdEntryEntryIdRoute,
  }

const CampaignShortIdMapNoteMapNoteIdRouteWithChildren =
  CampaignShortIdMapNoteMapNoteIdRoute._addFileChildren(
    CampaignShortIdMapNoteMapNoteIdRouteChildren,
  )

interface CampaignShortIdRouteChildren {
  CampaignShortIdJoinRoute: typeof CampaignShortIdJoinRoute
  CampaignShortIdIndexRoute: typeof CampaignShortIdIndexRoute
  CampaignShortIdMapNoteMapNoteIdRoute: typeof CampaignShortIdMapNoteMapNoteIdRouteWithChildren
}

const CampaignShortIdRouteChildren: CampaignShortIdRouteChildren = {
  CampaignShortIdJoinRoute: CampaignShortIdJoinRoute,
  CampaignShortIdIndexRoute: CampaignShortIdIndexRoute,
  CampaignShortIdMapNoteMapNoteIdRoute:
    CampaignShortIdMapNoteMapNoteIdRouteWithChildren,
}

const CampaignShortIdRouteWithChildren = CampaignShortIdRoute._addFileChildren(
  CampaignShortIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ColorsRoute: ColorsRoute,
  CreditsRoute: CreditsRoute,
  DesignSystemRoute: DesignSystemRouteWithChildren,
  ProfileRoute: ProfileRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  CampaignShortIdRoute: CampaignShortIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
